import 'reflect-metadata'

import { plainToInstance, Type } from 'class-transformer'
import { IsBoolean, IsIn, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator'
import { SaveLocation } from './save-location'

export class SaveFactory {
  public static build(raw: any) {
    return plainToInstance(SaveFactory, raw)
  }

  @IsNumber()
  @IsOptional()
  id?: number

  @IsString()
  @IsNotEmpty()
  name: string | undefined

  @IsNumber()
  @IsOptional()
  userId?: number | undefined

  @IsNumber()
  @IsNotEmpty()
  regionId: number | undefined

  @IsString()
  @IsOptional()
  color?: string

  @IsOptional()
  @ValidateNested()
  @Type(() => SaveLocation)
  location?: SaveLocation

  @IsString()
  @IsNotEmpty()
  region: string | undefined

  @IsNumber()
  @IsOptional()
  receptionSiteId?: number | undefined

  @IsBoolean()
  @IsOptional()
  active?: boolean

  @IsString()
  @IsOptional()
  @IsIn(['factory', 'depot'])
  type?: 'factory' | 'depot'
}
